import { TextField } from "@mui/material";

const MappingObjectText = ({ text }: { text: string }) => (
  <TextField
    variant="outlined"
    disabled
    value={text}
    sx={(theme) => ({ width: theme.spacing(25), bgcolor: theme.palette.background.grey })}
  />
);

export default MappingObjectText;
